import {SearchItem} from './geoapp';
interface ModalInstanceCtrlScope extends ng.IScope {
	items: { value: string }[];
	ok(item: SearchItem): void;
	gotoLocation(item: SearchItem): void;
	cancel(): void;
}
interface ModalInstance {
	close(): void;
	dismiss(value?: string): void;
}
export class ModalInstanceCtrl {
	public static $inject = ['$scope', '$uibModalInstance', 'searchService'];
	constructor($scope: ModalInstanceCtrlScope, $uibModalInstance: ModalInstance) {
		$scope.ok = function(item: SearchItem) {
			let myType = item.pxid ? 'Address' : 'Place';
			$scope.$root.$broadcast('search'+ myType, item);
			$uibModalInstance.close();
		};

		$scope.gotoLocation = (item: SearchItem) => {
			$scope.$root.$broadcast('searchModal', item);
			$uibModalInstance.close();
		};

		$scope.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
}
